import { useState, useCallback } from "react";
import Container from "../../common/Container";
import LoadingDisplay from "../../common/LoadingDisplay/LoadingDisplay";
import BlueScrollBackToTopButton from "../../common/BlueScrollBackToTopButton";
import ContentCard from "./ContentCard";
import useAsync from "../../../services/useAsync";
import PreloadReportedImageService from "../../../services/PreloadService/PreloadReportedImageService";

const ReportedImages = () => {
    const [isLoading, setIsloading] = useState(false);
    const {
        loadReportedImages,
        clearReportedImageFromSearch,
        deleteReportedImageCompletly,
        deleteReportedImageFromQueue,
        replaceReportedImages,
        reportedImages,
    } = PreloadReportedImageService();

    const deleteReportedImage = async (image) => {
        replaceReportedImages({ ...image, isLoading: true });

        const response = await deleteReportedImageCompletly(image);

        if (!response) replaceReportedImages({ ...image, isLoading: false });
    };

    const deleteReported = async (image) => {
        replaceReportedImages({ ...image, isLoading: true });

        const response = await deleteReportedImageFromQueue(image);

        if (!response) replaceReportedImages({ ...image, isLoading: false });
    };

    const deleteReportedImageFromSearch = async (image) => {
        replaceReportedImages({ ...image, isLoading: true });

        await clearReportedImageFromSearch(image);

        replaceReportedImages({ ...image, isLoading: false });
    };

    function timeConverter(timestamp) {
        return new Date(parseInt(timestamp)).toLocaleString();
    }

    let displayComponent = <></>;

    if (isLoading) {
        displayComponent = <LoadingDisplay />;
    }

    if (!isLoading) {
        displayComponent = (
            <div className="scrollableContainer">
                <BlueScrollBackToTopButton
                    buttonShowThreshold={1000}
                    left={true}
                />
                <Container
                    title="Reports"
                    content={
                        <ContentCard
                            reportedImages={reportedImages}
                            deleteReported={deleteReported}
                            deleteReportedImageFromSearch={
                                deleteReportedImageFromSearch
                            }
                            deleteReportedImage={deleteReportedImage}
                            timeConverter={timeConverter}
                        />
                    }
                    isNoBackground={true}
                />
            </div>
        );
    }

    if (reportedImages.length === 0 && !isLoading) {
        displayComponent = <Container title="NO REPORTED IMAGES" />;
    }

    const loadPage = useCallback(async () => {
        setIsloading(true);

        await Promise.all([loadReportedImages()]);

        setIsloading(false);
    }, [loadReportedImages]);

    useAsync(loadPage);

    return displayComponent;
};

export default ReportedImages;
